import type { LoanSizingResult } from '../../utils/financialCalculations';
import { formatCurrency } from '../../utils/financialCalculations';

interface Props { requested: number; sizing: LoanSizingResult; }

const CONSTRAINT_LABEL: Record<LoanSizingResult['constraint'], string> = {
  ltv: 'LTV', dscr: 'DSCR', debt_yield: 'debt yield', none: 'none',
};

export default function LoanSizingCard({ requested, sizing }: Props) {
  const headroom = sizing.maxLoan - requested;
  const short = headroom < 0;
  return (
    <div className={`rounded-xl border p-4 ${short ? 'bg-warning-wash border-warning/30' : 'bg-info-wash border-info/30'}`}>
      <h4 className="text-sm font-semibold uppercase tracking-wide text-gray-700 mb-2">Lender Sizing</h4>
      <div className="grid grid-cols-2 gap-x-6 gap-y-1 text-sm">
        <span className="text-gray-600">Requested loan</span>
        <span className="text-right font-medium">{formatCurrency(requested)}</span>
        <span className="text-gray-600">Max by LTV</span>
        <span className="text-right">{formatCurrency(sizing.byLtv)}</span>
        <span className="text-gray-600">Max by DSCR</span>
        <span className="text-right">{formatCurrency(sizing.byDscr)}</span>
        <span className="text-gray-600">Max by debt yield</span>
        <span className="text-right">{formatCurrency(sizing.byDebtYield)}</span>
      </div>
      <p className={`mt-3 text-sm font-medium ${short ? 'text-warning' : 'text-info'}`}>
        {short
          ? `Short by ${formatCurrency(Math.abs(headroom))}. Binding test: ${CONSTRAINT_LABEL[sizing.constraint]}. Add that much equity or renegotiate price.`
          : `Headroom of ${formatCurrency(headroom)}. Binding test: ${CONSTRAINT_LABEL[sizing.constraint]}.`}
      </p>
    </div>
  );
}
